import React from 'react';
import './App.css';
import Bio from './pages/Bio';
import Music from './pages/Music';
import Events from './pages/Events';
import Socials from './pages/Socials';
import Promo from './pages/Promo';

function App() {
  return (
    <div className="App">
      <header>
        <div className="logo">
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="TimeWaster Logo" />
        </div>
        <div className="hashtag-container">
          <span className="hashtag">#HappyHardcore</span>
          <span className="hashtag">#UKHardcore</span>
          <span className="hashtag">#HandsUp</span>
          <span className="hashtag">#Euphoric</span>
        </div>
        <p>DJ & Producer</p>
        <nav>
          <ul>
            <li><a href="#events">Events</a></li>
            <li><a href="#music">Music</a></li>
            <li><a href="#bio">Bio</a></li>
            {/* <li><a href="#promo">Promo</a></li> */}
            <li><a href="#socials">Socials</a></li>
          </ul>
        </nav>
      </header>
      <main>
        <Events />
        <Music />
        <Bio />
        {/* <Promo /> */}
        <Socials />
      </main>
      <footer>
        <p>&copy; {new Date().getFullYear()} TimeWaster. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
